<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/dashboard">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true" />&nbsp;Dashboard
      </b-breadcrumb-item>
      <b-breadcrumb-item v-if="employeeuserOnly == 1" to="/employee-approval-list">Tasks</b-breadcrumb-item>
      <b-breadcrumb-item active>
        Approval Detail View
        <!-- <strong>Requested by :</strong>
        {{approvalData.first_name + ' ' + approvalData.last_name}}-->
      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-row>
      <b-col cols="4" style="height: calc(100vh - 170px); overflow-y: auto;">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card class="text-left">
            <template v-slot:header>
              <h6 class="text-left">Details</h6>
            </template>
            <b-card-body>
              <p>
                <strong>Ref :</strong>
                {{approvalData.id}}
              </p>
              <p>
                <strong>Status :</strong>&nbsp;
                <b-badge v-if="approvalData.status == 1" variant="info">OPEN</b-badge>
                <b-badge v-else-if="approvalData.status == 2" variant="warning">COMPLETED</b-badge>
                <b-badge v-else-if="approvalData.status == 3" variant="danger">ON-HOLD</b-badge>
                <b-badge v-else-if="approvalData.status == 4" variant="success">APPROVED</b-badge>
                <b-badge v-else-if="approvalData.status == 5" variant="danger">REJECTED</b-badge>
              </p>
              <p>
                <strong>Currency :</strong>
                {{approvalData.currency}}
              </p>
              <!-- <p>Due Date = 10/5/2020</p> -->
            </b-card-body>
          </b-card>
        </b-overlay>
        <b-card class="mt-3" no-body>
          <b-card-title>Approvers</b-card-title>
          <b-card-body style="display: flex;justify-content: center;">
            <b-overlay :show="isLoadingApprovalTask" rounded="sm">
              <b-table-simple borderless small>
                <b-thead>
                  <b-tr>
                    <b-th>Approver</b-th>
                    <b-th>Status</b-th>
                    <b-th>Date</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(tasks, tasksIndex) in approvalTaskDetail" :key="tasksIndex">
                    <b-td>
                      <b-avatar
                        v-if="tasks.first_name && tasks.last_name && tasks.profile_img_url == null"
                        variant="success"
                        v-b-tooltip.hover.bottom="tasks.first_name+' '+tasks.last_name"
                      >{{getApproverName(tasks)}}</b-avatar>
                      <b-avatar
                        v-else-if="tasks.profile_img_url"
                        variant="info"
                        :src="tasks.profile_img_url"
                      ></b-avatar>
                    </b-td>
                    <b-td>
                      <b-badge v-if="tasks.status == '0'" variant="info">Pending</b-badge>
                      <b-badge v-if="tasks.status == '1'" variant="success">Approved</b-badge>
                      <b-badge v-if="tasks.status == '2'" variant="danger">Rejected</b-badge>
                      <b-badge v-if="tasks.status == '3'" variant="warning">In Progress</b-badge>
                    </b-td>
                    <b-td>{{tasks.approved_at ? tasks.approved_at : 'N/A'}}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-overlay>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col cols="8" style="height: calc(100vh - 170px); overflow-y: auto;">
        <b-card class="shadow-sm">
          <b-tabs>
            <b-tab
              title="DETAILS"
              active
              class="text-left"
              style="height: calc(100vh - 230px); overflow: hidden auto;"
            >
              <b-modal
                :title="addNoteTitle"
                v-model="showAddNotesModal"
                size="lg"
                scrollable
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close
              >
                <div>
                  <div class="text-center" v-if="!submiting && !responseSuccess">
                    <label v-if="notesStatus == 3">
                      Please Enter Additional Information:
                      <span class="required-span">*</span>
                    </label>
                    <label v-if="notesStatus == 2">
                      Please Enter the resons for your Rejection:
                      <span class="required-span">*</span>
                    </label>
                    <wysiwyg
                      :class="invalidApproveNotes != null ? 'approve-notes' : ''"
                      v-model="notesInput"
                    />
                    <p
                      v-if="invalidApproveNotes"
                      class="text-danger text-center mt-1"
                    >{{invalidApproveNotes}}</p>
                  </div>
                  <div v-else-if="submiting && !responseSuccess">
                    <p>Your Notes is being adding......</p>
                    <b-spinner type="grow" label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    <p class="my-2 text-center">
                      Your Note has been Added successfully.
                      <br />
                    </p>
                  </div>
                </div>
                <template v-slot:modal-footer>
                  <b-button v-if="!submiting" @click="closeModal" variant="outline-danger">Close</b-button>
                  <b-button
                    v-if="!submiting && !responseSuccess"
                    @click="addNotes"
                    variant="outline-success"
                  >{{notesStatus == 3 ? 'Send' : notesStatus == 2 ? 'Reject' : 'Approve'}}</b-button>
                </template>
              </b-modal>
              <b-row>
                <b-col cols="6">
                  <p>
                    <strong>Requested by :</strong>
                    {{approvalData.first_name + ' ' + approvalData.last_name}}
                  </p>
                  <p>
                    <strong>Gift Type :</strong>
                    {{approvalData.title}}
                  </p>
                  <p>
                    <strong>Created Date :</strong>
                    {{dateFormat(approvalData.created_at)}}
                  </p>
                  <p>
                    <strong>Amount :</strong>
                    {{approvalData.amount}}
                  </p>
                  <p>
                    <strong>Description :</strong>
                    {{approvalData.meta_data ? JSON.parse(approvalData.meta_data).description : ""}}
                  </p>
                </b-col>
                <b-col cols="6">
                  <b-overlay :show="isLoadingComments" rounded="sm">
                    <div style="height: calc(100vh - 275px);overflow-y: auto;">
                      <ul class="timeline" style="margin-bottom: 50px;">
                        <li v-for="(notes,index) in notesData" :key="index">
                          <p class="text-muted">
                            {{ formatDate(notes.created_at) }}&nbsp;{{notes.first_name + ' ' + notes.last_name}}
                            <span
                              v-if="notes.status == 1"
                            >
                              has
                              <b-badge variant="success">Approved</b-badge>
                            </span>
                            <span v-if="notes.status == 2">
                              has
                              <b-badge variant="danger">Rejected</b-badge>
                            </span>
                            <span v-if="notes.status == 3">
                              has
                              <b-badge variant="warning">Requested Additional Information</b-badge>
                            </span>
                          </p>
                          <p> {{ notes.notes }}</p>
                        </li>
                      </ul>
                    </div>
                    <div style="margin-bottom: 40px;margin-top: 15px;" v-if="employeeuserOnly == 1">
                      <b-button
                        v-if="approvedGift"
                        class="float-right mr-2"
                        variant="outline-success"
                        size="sm"
                        @click="onShowNoteModal('Approve')"
                      >Approve</b-button>
                      <b-button
                        v-if="rejectedGift"
                        class="float-right mr-2"
                        variant="outline-danger"
                        size="sm"
                        @click="onShowNoteModal('Reject')"
                      >Reject</b-button>
                      <b-button
                        class="float-right mr-2"
                        variant="outline-warning"
                        size="sm"
                        @click="onShowNoteModal('Reqiue Additional Information')"
                      >Reqiue Additional Information</b-button>
                    </div>
                  </b-overlay>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab
              v-if="employeeuserOnly == 1"
              title="DOCUMENTS"
              :lazy="fileUploadTabLazy"
              style="height: calc(100vh - 180px); overflow: hidden auto;"
            >
              <b-overlay :show="isLoadingApprovalFiles" rounded="sm">
                <div style="height: calc(100vh - 235px);overflow-y: auto;overflow-x: hidden;">
                  <b-navbar toggleable="lg" type="dark" variant="light">
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-navbar-brand href="#" class="text-dark">
                      <strong>Approval Files</strong>
                    </b-navbar-brand>

                    <b-collapse id="nav-collapse" is-nav>
                      <b-navbar-nav class="ml-auto">
                        <b-nav-form>
                          <b-button
                            @click="showUploadModal = !showUploadModal"
                            class="my-2 my-sm-0 mr-2"
                            variant="outline-primary"
                            size="sm"
                          >
                            <!-- <font-awesome-icon icon="plus" /> -->
                            Add
                          </b-button>
                          <b-button
                            variant="outline-info"
                            size="sm"
                            class="mr-2"
                            @click="reloadTableFilesTable"
                          >
                            <font-awesome-icon icon="sync" />
                            Reload
                          </b-button>
                        </b-nav-form>
                      </b-navbar-nav>
                    </b-collapse>
                  </b-navbar>
                  <b-table
                    bordered
                    class="mx-1"
                    sticky-header="calc(100vh - 220px)"
                    ref="table"
                    id="my-approval-files-table"
                    :busy.sync="isLoadingApprovalFiles"
                    :fields="filesTableFields"
                    :items="getApprovalFiles"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                  >
                    <template v-slot:cell(created_at)="data">
                      <p>{{ createdAtDate(data.item.created_at) }}</p>
                    </template>
                    <template
                      v-slot:cell(contact_name)="data"
                    >{{data.item.first_name + ' ' + data.item.last_name}}</template>
                    <template v-slot:cell(actions)="data">
                      <b-btn size="sm" variant="outline-danger" @click="downloadFile(data)">
                        <font-awesome-icon icon="download" />
                      </b-btn>
                    </template>
                  </b-table>
                  <p class="mt-3">Current Page: {{ perPage }} rows</p>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="perPage"
                        id="perPageSelect"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col>
                      <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="my-approval-files-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-overlay>
              <b-modal
                title="File Upload"
                v-model="showUploadModal"
                size="lg"
                scrollable
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close
              >
                <div>
                  <div class="text-center" v-if="!submiting && !responseSuccess">
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      v-on:vdropzone-sending="sendingEvent"
                      @vdropzone-success="vsuccess"
                      :options="dropzoneOptions"
                      :useCustomSlot="true"
                      class="m-5 p-3"
                      style="border:dashed 1px"
                    >
                      <div class="dropzone-custom-content">
                        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                        <div class="subtitle">...or click to select a file from your computer</div>
                      </div>
                    </vue-dropzone>
                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Display Name">
                      <b-form-input type="text" v-model="uploadFileDisplayName" size="sm" />
                    </b-form-group>
                  </div>
                  <div v-else-if="submiting && !responseSuccess">
                    <p>Your File is being Uploading......</p>
                    <b-spinner type="grow" label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    <p class="my-2 text-center">
                      Your File has been uploaded successfully.
                      <br />
                    </p>
                  </div>
                </div>
                <template v-slot:modal-footer>
                  <div class="float-right">
                    <b-button
                      class="mr-3"
                      variant="outline-danger"
                      v-if="!uploading"
                      @click="resetUploadModal"
                    >Cancel</b-button>
                    <b-button
                      variant="outline-success"
                      v-if="!uploading && !responseSuccess"
                      @click="uploadFileApiCall"
                    >Upload</b-button>
                  </div>
                </template>
              </b-modal>
            </b-tab>
            <b-tab
              title="HISTORY"
              :lazy="employeeApprovalsTabLazy"
              style="height: calc(100vh - 180px); overflow: hidden auto;"
            >
              <b-overlay :show="isLoadingEmployeeApprovals" rounded="sm">
                <b-navbar toggleable="lg" type="dark" variant="light">
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand href="#" class="text-dark">
                    <strong>Gifts History</strong>
                  </b-navbar-brand>

                  <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="reloadTableEmployeeApprovals"
                        >
                          <!-- <font-awesome-icon icon="sync" /> -->
                          Reload
                        </b-button>
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  class="mx-1"
                  sticky-header="calc(100vh - 220px)"
                  :busy.sync="isLoadingEmployeeApprovals"
                  bordered
                  fixed
                  ref="table"
                  id="my-employee-approvals-table"
                  :fields="employeeApprovalsFields"
                  :items="getEmployeeApprovalsData"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                >
                  <template v-slot:cell(created_at)="data">{{ createdAtDate(data.item.created_at) }}</template>
                  <template v-slot:cell(status)="data">
                    <b-badge v-if="data.item.status == 1" variant="info">OPEN</b-badge>
                    <b-badge v-else-if="data.item.status == 2" variant="warning">COMPLETED</b-badge>
                    <b-badge v-else-if="data.item.status == 3" variant="danger">ON-HOLD</b-badge>
                    <b-badge v-else-if="data.item.status == 4" variant="success">APPROVED</b-badge>
                    <b-badge v-else-if="data.item.status == 5" variant="danger">REJECTED</b-badge>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-btn
                      :to="'/gifts-approval/'+data.item.id+'/1'"
                      size="sm"
                      variant="outline-warning"
                    >
                      <font-awesome-icon icon="eye" />
                    </b-btn>
                  </template>
                </b-table>
                <p class="mt-3">Current Page: {{ perPage }} rows</p>
                <b-row>
                  <b-col cols="2">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      aria-controls="my-employee-approvals-table"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-tab>
            <b-tab title="ACTIVITY" style="height: calc(100vh - 180px); overflow-y: auto;">
              <b-card>
                <template v-slot:header>
                  <b-row>
                    <b-col cols="6">
                      <h6 class="text-left">Activity</h6>
                    </b-col>
                    <b-col cols="6">
                      <div class="float-right">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="getApprovalActivityLog"
                        >
                          <font-awesome-icon icon="sync" />
                          Reload
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                </template>
                <b-card-body>
                  <div id="container" class="scrollFlow" style>
                    <b-row>
                      <b-col cols="12">
                        <b-overlay :show="isLoadingActivityLog" rounded="sm">
                          <div>
                            <ul class="timeline" style="margin-bottom: 50px;">
                              <li v-for="(logData,index) in activityLogData" :key="index">
                                <p class="text-muted">{{ formatDate(logData.created_at) }}</p>
                                <p>{{logData.notes}}</p>
                              </li>
                            </ul>
                          </div>
                        </b-overlay>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../../components/Dropzone/VueDropzone";
import moment from "moment";
import "moment/locale/es";
import axios from "axios";
import config from "../../configs/config";
import { Helper } from "../../helpers";
export default {
  name: "ViewComplaints",
  components: {
    VueDropzone,
  },
  data() {
    return {
      approvedGift: true,
      rejectedGift: true,
      employeeApprovalsTabLazy: true,
      isLoadingEmployeeApprovals: false,
      filter: null,
      employeeApprovalsFields: [
        {
          key: "created_at",
          label: "Age",
          sortable: true,
        },
        {
          key: "title",
          label: "Approval Type",
          sortable: true,
        },
        // { key: "currency", label: "Currency", sortable: true },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
      fileUploadTabLazy: true,
      showAddNotesModal: false,
      showUploadModal: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      filesTableFields: [
        {
          key: "created_at",
          label: "Uploaded At",
          sortable: true,
        },
        {
          key: "contact_name",
          label: "Employee",
          sortable: true,
        },
        {
          key: "display_name",
          label: "Display Name",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
      isLoadingApprovalFiles: false,
      submiting: false,
      responseSuccess: false,
      uploading: false,
      invalidApproveNotes: null,
      approvalData: {},
      isLoading: false,
      isLoadingComments: false,
      notesInput: null,
      notesData: [],
      uploadFileDisplayName: null,
      dropzoneOptions: {
        url:
          process.env.VUE_APP_API_URL +
          "api/v1/approvals/files/upload/" +
          this.$route.params.approvalId,
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      },
      approvalTaskDetail: [],
      isLoadingApprovalTask: false,
      addNoteTitle: null,
      notesStatus: 0,
      employeeuserOnly: 0,
      activityLogSortBy: "id",
      activityLogSortDesc: true,
      isLoadingActivityLog: false,
      activityLogData: [],
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {
    this.employeeuserOnly = this.$route.params.userType;
    if (this.$route.params.userType == 2) {
      this.$store.state.employeeDashboardTabIndex = 1;
    }
    this.getApprovalsDetail();
    this.getApproverNotesList();
    this.getApprovalTaskDetail();
    this.getApprovalActivityLog();
  },
  methods: {
    getApproverName(data) {
      let firstName = data.first_name.toUpperCase();
      let lastName = data.last_name.toUpperCase();
      let name = firstName.charAt(0) + lastName.charAt(0);

      return name;
    },
    async getApprovalActivityLog() {
      let formData = {
        activity_log_model_id: this.$route.params.approvalId,
        activity_log_type: "Approvals",
        user_id: localStorage.getItem("userId"),
        sort:
          this.activityLogSortBy +
          "|" +
          (this.activityLogSortDesc == true ? "desc" : "asc"),
      };
      this.isLoadingActivityLog = true;
      let response = await HTTP(
        "post",
        "api/v1/activitylog/get/with/type",
        formData
      );
      try {
        this.activityLogData = response.data.data;
        this.isLoadingActivityLog = false;
      } catch (err) {
        this.isLoadingActivityLog = false;
        return [err];
      } finally {
        this.scrollToEnd();
        this.isLoadingActivityLog = false;
      }
    },
    scrollToEnd() {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight + 120;
    },
    onShowNoteModal(title) {
      this.showAddNotesModal = true;
      this.addNoteTitle = title;
      if (title == "Approve") {
        this.notesStatus = 1;
      } else if (title == "Reject") {
        this.notesStatus = 2;
      } else if (title == "Reqiue Additional Information") {
        this.notesStatus = 3;
      }
    },
    reloadTableEmployeeApprovals() {
      this.$root.$emit("bv::refresh::table", "my-employee-approvals-table");
    },
    async getEmployeeApprovalsData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        employee_id: this.approvalData.employee_id,
      };
      this.isLoadingEmployeeApprovals = true;
      let response = await HTTP("post", "api/v1/approvals/get", formData);
      try {
        this.totalRows = response.data.total;
        this.isLoadingEmployeeApprovals = false;
        this.employeeApprovalsTabLazy = false;
        return response.data.data;
      } catch (err) {
        this.isLoadingEmployeeApprovals = false;
        this.employeeApprovalsTabLazy = false;
        return [err];
      } finally {
        this.isLoadingEmployeeApprovals = false;
        this.employeeApprovalsTabLazy = false;
      }
    },
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    async getApprovalTaskDetail() {
      this.approvalTaskDetail = [];
      this.isLoadingApprovalTask = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/approvals/get/approval/tasks/Detail/" +
            this.$route.params.approvalId,
          null
        );
        this.approvalTaskDetail = result.data.approvaltasks;
        this.isLoadingApprovalTask = false;
      } catch (error) {
        this.isLoadingApprovalTask = false;
      }
    },
    reloadTableFilesTable() {
      this.$root.$emit("bv::refresh::table", "my-approval-files-table");
    },
    async getApprovalFiles() {
      let formData = {
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoadingApprovalFiles = true;
      let response = await HTTP(
        "post",
        "api/v1/approvals/get/files/" + this.$route.params.approvalId,
        formData
      );
      try {
        this.totalRows = response.data.total;
        this.isLoadingApprovalFiles = false;
        this.fileUploadTabLazy = false;
        return response.data.data;
      } catch (err) {
        this.isLoadingApprovalFiles = false;
        this.fileUploadTabLazy = false;
        return [err];
      } finally {
        this.isLoadingApprovalFiles = false;
        this.fileUploadTabLazy = false;
      }
    },
    formatDate(value) {
      if (value) {
        moment.locale("en");
        return moment(String(value)).format("DD MMMM, YYYY - h:mm:ss");
      }
    },
    dateFormat(value) {
      if (value) {
        moment.locale("en");
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    async getApproverNotesList() {
      this.notesData = [];
      this.isLoadingComments = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/approvals/get/approver/notes/" +
            this.$route.params.approvalId,
          null
        );
        this.notesData = result.data.approvalNotes;
        let approvedGiftIndex = null;
        let rejectedGiftIndex = null;
        let employeeId = localStorage.getItem("employeeId");

        approvedGiftIndex = result.data.approvalNotes.findIndex(
          (i) => i.status == "1"
        );
        rejectedGiftIndex = result.data.approvalNotes.findIndex(
          (i) => i.status == "2"
        );
        if (
          result.data.approvalNotes[approvedGiftIndex].employee_id == employeeId
        ) {
          if (approvedGiftIndex != -1) {
            this.approvedGift = false;
          } else {
            this.approvedGift = true;
          }
        } else {
          this.approvedGift = true;
        }
        if (
          result.data.approvalNotes[rejectedGiftIndex].employee_id == employeeId
        ) {
          if (rejectedGiftIndex != -1) {
            this.rejectedGift = false;
          } else {
            this.rejectedGift = true;
          }
        } else {
          this.rejectedGift = true;
        }
        this.isLoadingComments = false;
      } catch (error) {
        this.isLoadingComments = false;
      }
    },
    addNotes() {
      if (this.notesStatus == 1) {
        this.addApproverComments();
      } else {
        if (this.notesInput != null) {
          this.addApproverComments();
        } else {
          this.invalidApproveNotes = "Plase Enter Something.";
        }
      }
    },
    async addApproverComments() {
      let formData = {
        status: this.notesStatus,
        note: this.notesInput,
        user_id: localStorage.getItem("userId"),
        employee_id: localStorage.getItem("employeeId"),
        requester_employee_id: this.approvalData.employee_id,
      };
      try {
        this.submiting = true;
        this.isLoadingComments = true;
        await HTTP(
          "post",
          "api/v1/approvals/add/approver/notes/" +
            this.$route.params.approvalId,
          formData
        );
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComments = false;
        var data = {
          created_at: new Date(),
          note: this.notesInput,
        };
        this.notesData.push(data);
        this.notesInput = null;
        this.invalidApproveNotes = null;
        this.getApproverNotesList();
        this.getApprovalTaskDetail();
        this.getApprovalsDetail();
        this.getApprovalActivityLog();
        this.closeModal();
        Helper.makeToast(
          this.$bvToast,
          "success",
          "Note Has Been successfully Added"
        );
      } catch (err) {
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComments = false;
        return [err];
      }
    },
    closeModal() {
      this.isLoadingComments = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showAddNotesModal = false;
      this.notesInput = null;
      this.invalidApproveNotes = null;
      this.notesStatus = 0;
    },
    async deleteNote(notes) {
      this.isLoadingComments = true;
      try {
        await HTTP(
          "get",
          "api/v1/approvals/delete/approver/notes/" + notes.id + "/" + localStorage.getItem("userId"),
          null
        );
        this.isLoadingComments = false;
        this.getApproverNotesList();
      } catch (error) {
        this.isLoadingComments = false;
      }
    },
    async getApprovalsDetail() {
      this.approvalData = {};
      let fromData = {
        approval_id: this.$route.params.approvalId,
        user_id: localStorage.getItem("userId"),
      };
      this.isLoading = true;
      let result = HTTP("post", "api/v1/approvals/detail", fromData);
      return result
        .then((response) => {
          this.approvalData = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
    uploadFileApiCall() {
      if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
        this.uploading = true;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    vsuccess() {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      this.$bvToast.toast(
        "Your file has been successfully uploaded and is now processed",
        {
          title: "File Upload is complete",
          noAutoHide: false,
          appendToast: true,
        }
      );
      this.$refs.myVueDropzone.removeAllFiles();
      this.reloadTableFilesTable();
    },
    sendingEvent(file, xhr, formData) {
      formData.append("employee_id", localStorage.getItem("employeeId"));
      formData.append("displayName", this.uploadFileDisplayName);
      formData.append("user_id", localStorage.getItem("userId"));
    },
    resetUploadModal() {
      this.isLoadingApprovalFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
      this.getApprovalActivityLog();
    },
    async downloadFile(data) {
      let titleForm = data.item.filename;
      axios({
        url: config.API_URL + "api/v1/approvals/file/download/" + data.item.id,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([response.data]);
            // IE11
            window.navigator.msSaveOrOpenBlob(blob, titleForm);
            Helper.makeToast(
              this.$bvToast,
              "success",
              "File has been download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", titleForm); //or any other extension
            document.body.appendChild(link);
            link.click();
            if (response) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                "File has been download successfully"
              );
            }
          }
        })
        .catch((error) => {
          Helper.makeToast(this.$bvToast, "danger", "Unable to download file.");
          return [error];
        });
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";

.body-card {
  padding: 0;
}

.approve-notes {
  border: 2px solid rgb(200 39 51) !important;
}
</style>
